import type { ReactNode } from 'react'

import { useButton, type TUseButtonProps } from './../../useButton.web'

type TButtonProps = TUseButtonProps

export const Button = ({ ref, ...props }: TButtonProps): ReactNode => {
  const {
    children,
    styles,
    spinner,
    spinnerPlacement,
    startContent,
    endContent,
    isLoading,
    getButtonProps,
    isIconOnly,
  } = useButton({ ...props })

  const { ...buttonProps } = getButtonProps()

  return (
    // we can use html button element here because we are using this component only in web platform
    <div role="button" ref={ref} className={styles} {...buttonProps}>
      {startContent}
      {!!(isLoading && spinnerPlacement === 'start') && spinner}
      {!isIconOnly && children}
      {!!(isLoading && spinnerPlacement === 'end') && spinner}
      {endContent}
    </div>
  )
}

Button.displayName = 'NextUI.Button'
